/**
 * Shared promise that resolves once Firebase auth state is first determined.
 *
 * Before this resolves, `getAuth().currentUser` is always null — even if the
 * user has a persisted session in localStorage.  Any code that needs a valid
 * Firebase token should `await authReady` first.
 *
 * If Firebase is not configured on the page, call `signalAuthReady()` from
 * the application entrypoint so the promise resolves immediately and nothing
 * blocks.
 */

let _resolve: () => void;
let _resolved = false;

export const authReady = new Promise<void>((resolve) => {
  _resolve = resolve;
});

export function signalAuthReady(): void {
  if (!_resolved) {
    _resolved = true;
    _resolve();
  }
}
